import { appEnv } from 'app/core/environment';
import Axios from 'axios-observable';
import { pluck } from 'rxjs/operators';
import { manageResponseData } from '../api-core/api-request-utils';
import apiResourceHookFactory from '../api-core/utility-factories/api-resource-hook-factory';
import { apiRedux } from '../api-redux';
import { GoogleGeolocation } from './api-google-geolocation.types';

const GOOGLE_GEOLOCATE_URL =
  'https://www.googleapis.com/geolocation/v1/geolocate';

export const googleGeolocation$ = Axios.post<GoogleGeolocation>(
  GOOGLE_GEOLOCATE_URL,
  null,
  { params: { key: appEnv.GOOGLE_API_KEY } }
).pipe(pluck('data'), manageResponseData());

export const useGoogleGeolocation = apiResourceHookFactory(
  apiRedux.googleGeolocation,
  () => googleGeolocation$
);
